<nz-layout class="eoc-section" [ngClass]="{ 'eoc-section-discharge-report': isDischargeReportOpen }">
  <nz-header> </nz-header>
  <nz-content>
    @if (isDischargeReportOpen) {
      <app-discharge-report-preview />
    } @else {
      @if (hasConfiguredSubmenu) {
        @for (item of submenu; track item.path) {
          @if (item.path === componentPaths.activeEpisodeOfCare) {
            <app-active-eoc [id]="item.path" />
          }

          @if (item.path === componentPaths.pastEpisodeOfCare) {
            <app-past-eoc [id]="item.path" />
          }
        }
      } @else {
        <app-active-eoc />
        <app-past-eoc />
      }
    }
  </nz-content>
</nz-layout>